import React from 'react';
import PropTypes from 'prop-types';

import Chip from './Chip';
import { esTeleconsulta, MODALIDAD_LABEL, MODALIDAD_PRESENCIAL, MODALIDAD_TELEMEDICINA } from '../../utils/modalidadCita';

// Distintivo de modalidad de la cita. Hasta ahora la modalidad se elegia al
// agendar y despues desaparecia de la vista del profesional: ni el dashboard ni
// la agenda ni la ficha la mostraban, y el unico que la veia era el paciente en
// "Mi cita". Sin saber en que recorrido esta, el profesional recibe las acciones
// de los dos a la vez.
//
// Va con icono ademas de texto porque en la agenda del dia se lee de un vistazo
// y en fila: el icono es lo que se distingue sin leer.
const ModalidadChip = ({ modalidad, size = 'md', ...props }) => {
  const teleconsulta = esTeleconsulta({ modalidad });
  const compacto = size === 'sm';

  return (
    <Chip
      variant={teleconsulta ? 'default' : 'outline'}
      px={compacto ? 2 : 3}
      py={0}
      minH={compacto ? '18px' : '22px'}
      fontSize={compacto ? '10px' : '12px'}
      display="inline-flex"
      alignItems="center"
      gap="4px"
      textTransform="none"
      {...props}
    >
      <i className="material-icons" style={{ fontSize: compacto ? '12px' : '14px' }} aria-hidden="true">
        {teleconsulta ? 'videocam' : 'person'}
      </i>
      {MODALIDAD_LABEL[teleconsulta ? MODALIDAD_TELEMEDICINA : MODALIDAD_PRESENCIAL]}
    </Chip>
  );
};

ModalidadChip.propTypes = {
  modalidad: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default ModalidadChip;
